import GET from "./api/GET";

export const fetchAreaList = async () => {
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/location/areas`
  );
  return response;
};

export const fetchBlockList = async (area) => {
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/location/blocks/${area}`
  );
  return response;
};

export const fetchStreetList = async (area, block) => {
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/location/streets/${area}/${block}`
  );
  return response;
};

export const calculateDeliveryFee = async (endLatitude, endLongitude) => {
  const currentBranch = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch"
  );
  const startLatitude = JSON.parse(currentBranch)?.latitude;
  const startLongitude = JSON.parse(currentBranch)?.longitude;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/location/calculate-delivery-fee?startLatitude=${startLatitude}&startLongitude=${startLongitude}&endLatitude=${endLatitude}&endLongitude=${endLongitude}`
  );
  return response;
};
